<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="disableOrigem"
                            :options="form.origens"
                            @change="loadFrom('origem')"
                            default-option-text="Todas"
                            label="Origem"
                            show-default-option
                            text-field="nome"
                            v-model="model.origemId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="disableUnidade"
                            :options="form.unidades"
                            @change="loadFrom('unidade')"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="disableInfraestrutura"
                            :options="form.infraestruturas"
                            @change="loadFrom('infraestrutura')"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="disableOcupacao"
                            :options="form.ocupacoes"
                            @change="loadFrom('ocupacao')"
                            default-option-text="Todas"
                            label="CBO"
                            show-default-option
                            text-field="descricao"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="disableUsuario"
                            :options="form.usuarios"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-button
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <rkm-table
                :fields="columns"
                :items="itens"
                sort-by="dataAtendimento"
            >
                <template #cell(actions)="{ item }">
                    <rkm-button
                        @click="openModal(item)"
                        color="primary"
                        small
                        title="Visualizar"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <ModalAtendimentoDomiciliar ref="ModalAtendimentoDomiciliar" />
        <ModalFichaComplementar ref="ModalFichaComplementar" />
        <ModalAvaliacao ref="ModalAvaliacao" />
        <ModalConsumoAlimentar ref="ModalConsumoAlimentar" />
        <ModalProcedimento ref="ModalProcedimento" />
        <ModalVisitaDomiciliar ref="ModalVisitaDomiciliar" />
        <ModalAtendimentoIndividual ref="ModalAtendimentoIndividual" />
        <ModalAtendimentoOdontologico ref="ModalAtendimentoOdontologico" />
        <ModalAtividadeColetiva ref="ModalAtividadeColetiva" />
        <ModalFichaVacinacao ref="ModalFichaVacinacao" />
        <ModalCadastroIndividual ref="ModalCadastroIndividual" />
        <ModalCadastroDomiciliar ref="ModalCadastroDomiciliar" />
    </div>
</template>

<script>
// Components.
import ModalAtendimentoDomiciliar from './components/atendimento-domiciliar/Modal'
import ModalFichaComplementar from './components/ficha-complementar/Modal'
import ModalAvaliacao from './components/avaliacao/Modal'
import ModalConsumoAlimentar from './components/consumo-alimentar/Modal'
import ModalProcedimento from './components/procedimento/Modal'
import ModalVisitaDomiciliar from './components/visita-domiciliar/Modal'
import ModalAtendimentoIndividual from './components/atendimento-individual/Modal'
import ModalAtendimentoOdontologico from './components/atendimento-odontologico/Modal'
import ModalAtividadeColetiva from './components/atividade-coletiva/Modal'
import ModalFichaVacinacao from './components/ficha-vacinacao/Modal'
import ModalCadastroIndividual from './components/cadastro-individual/Modal'
import ModalCadastroDomiciliar from './components/cadastro-domiciliar/Modal'

// Mixins.
import { repository, formats, error, data, object, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Enums.
import origem from '@/enums/integracao/esus/origem'

export default {
    components: {
        ModalAtendimentoDomiciliar,
        ModalFichaComplementar,
        ModalAvaliacao,
        ModalConsumoAlimentar,
        ModalProcedimento,
        ModalVisitaDomiciliar,
        ModalAtendimentoIndividual,
        ModalAtendimentoOdontologico,
        ModalAtividadeColetiva,
        ModalFichaVacinacao,
        ModalCadastroIndividual,
        ModalCadastroDomiciliar,
    },
    computed: {
        validations() {

            return {
                periodo: { required: true },
            }
        },
        disableOrigem() {

            return !this.isPeriodoSelecionado
        },
        disableUnidade() {

            return !this.isPeriodoSelecionado
        },
        disableInfraestrutura() {

            return !this.model.unidadeId
        },
        disableOcupacao() {

            return !this.isPeriodoSelecionado
        },
        disableUsuario() {

            return !this.isPeriodoSelecionado
        },
        isPeriodoSelecionado() {

            return this.model !== null
                && (this.model.periodo.start instanceof Date)
                && (this.model.periodo.end instanceof Date)
        },
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            initials: {
                form: null,
                model: null,
            },
            columns: [
                {
                    key: 'dataAtendimento',
                    label: 'Data de atendimento',
                    sortable: true,
                    class: 'col-min',
                    formatter: value => this.formatDate(value),
                    filterByFormatted: true,
                },
                { key: 'origemNome', label: 'Origem', sortable: true },
                { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                { key: 'ocupacaoDescricao', label: 'CBO', sortable: true },
                { key: 'usuarioNome', label: 'Profissional', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
            itens: [],
            enums: { origem },
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.initials.form = this.clone(data.form)
                    this.initials.model = this.clone(data.model)

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        openModal(inconsistencia) {

            switch (inconsistencia.origemId) {

                case this.enums.origem.ATENDIMENTO_DOMICILIAR: {

                    this.$refs.ModalAtendimentoDomiciliar.open(inconsistencia)

                    break
                }
                case this.enums.origem.FICHA_COMPLEMENTAR: {

                    this.$refs.ModalFichaComplementar.open(inconsistencia)

                    break
                }
                case this.enums.origem.AVALIACAO: {

                    this.$refs.ModalAvaliacao.open(inconsistencia)

                    break
                }
                case this.enums.origem.CONSUMO_ALIMENTAR: {

                    this.$refs.ModalConsumoAlimentar.open(inconsistencia)

                    break
                }
                case this.enums.origem.PROCEDIMENTO: {

                    this.$refs.ModalProcedimento.open(inconsistencia)

                    break
                }
                case this.enums.origem.VISITA_DOMICILIAR: {

                    this.$refs.ModalVisitaDomiciliar.open(inconsistencia)

                    break
                }
                case this.enums.origem.ATENDIMENTO_INDIVIDUAL: {

                    this.$refs.ModalAtendimentoIndividual.open(inconsistencia)

                    break
                }
                case this.enums.origem.ATENDIMENTO_ODONTOLOGICO: {

                    this.$refs.ModalAtendimentoOdontologico.open(inconsistencia)

                    break
                }
                case this.enums.origem.ATIVIDADE_COLETIVA: {

                    this.$refs.ModalAtividadeColetiva.open(inconsistencia)

                    break
                }
                case this.enums.origem.FICHA_VACINACAO: {

                    this.$refs.ModalFichaVacinacao.open(inconsistencia)

                    break
                }
                case this.enums.origem.CADASTRO_INDIVIDUAL: {

                    this.$refs.ModalCadastroIndividual.open(inconsistencia)

                    break
                }
                case this.enums.origem.CADASTRO_DOMICILIAR: {

                    this.$refs.ModalCadastroDomiciliar.open(inconsistencia)

                    break
                }
            }
        },
        addWatchers() {

            this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    if (periodo.start === null || periodo.end === null) {

                        this.resetAfterPeriodo()
                    }
                    else {

                        this.loadFrom('periodo')
                    }
                }
            })
        },
        loadFrom(field) {

            this.clearFrom(field)

            this.setLoading()

            this.repositories.gerenciamentoEnvio.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(({ data }) => {

                    if ('form' in data) {

                        Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
                    }

                    Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearFrom(field) {

            if (field == 'periodo') {

                return
            }

            field = `${field}Id`

            const fields = [
                'origemId',
                'unidadeId',
                'infraestruturaId',
                'ocupacaoId',
                'usuarioId',
            ]

            fields.slice(fields.indexOf(field) + 1, fields.length)
                .forEach(key => this.$set(this.model, key, null))
        },
        search() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.index(this.prepareData())
                .then(({ data }) => this.itens = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.form = this.clone(this.initials.form)
            this.model = this.clone(this.initials.model)

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        resetAfterPeriodo() {

            this.form = this.clone(this.initials.form)

            const model = this.clone(this.initials.model)

            delete model.periodo

            Object.keys(model).forEach(key => this.$set(this.model, key, model[key]))
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, formats, error, data, object, stringCase],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
            }
        },
    }
}
</script>
